import { graphql } from 'gql'

export const UPDATE_YIELDBIRD_DEMAND_REPORT = graphql(`
  mutation updateYieldbirdDemandReportUrl($input: UpdateWorkspaceInput!) {
    updateWorkspace(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
